module.exports = __webpack_public_path__ + "assets/img/logo.f6fe60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 299
// module chunks = 2